/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTransfer} from '../api'

 export const useQueryGetTransfer = createReactQueryHook('getTransfer', getTransfer)
